<mat-sidenav-content role="main" id='contenido' style="overflow:hidden!important">
  <router-outlet></router-outlet>
  

</mat-sidenav-content>
